class User {
    constructor(id, roleId, username, trueName, status) {
        this.id = id;
        this.roleId = roleId;
        this.username = username;
        this.trueName = trueName;
        this.status = status;
    }

    isStudent() {
        return this.roleId === 1;
    }

    isTeacher() {
        return this.roleId === 2;
    }

    isAdmin() {
        return this.roleId === 3;
    }
}

let currentUser = null;
export default {
    User,
    setCurrentUser(user) {
        currentUser = user;
        localStorage.setItem('currentUser', JSON.stringify(user));
    },
    getCurrentUser() {
        if (!currentUser) {
            const stored = localStorage.getItem('currentUser');
            if (stored) {
                const userData = JSON.parse(stored);
                currentUser = new this.User(
                    userData.id,
                    userData.roleId,
                    userData.username,
                    userData.trueName,
                    userData.status
                );
            }
        }
        return currentUser;
    },
    clearCurrentUser() {
        currentUser = null;
        localStorage.removeItem('currentUser');
    }
};
